import { render } from "./DocumentsView.vue?vue&type=template&id=79bbcc3c"
import script from "./DocumentsView.vue?vue&type=script&lang=js"
export * from "./DocumentsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__